
    import { mapGetters } from "vuex";

export default {
        props: [],
        components: {

        },
        data : function(){
            return {
                chosenImageIndex:0,
                prevRoute: null,
                show_scheduling_flag: null
            };
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.prevRoute = from
            })
        },
        computed: {

            ...mapGetters({
                 productStock: "getProductStock",
             }),

            swiper() {
                return this.$refs.imageSwiper.$swiper
            },

            swiperOptions() {
                return {
                    notNextTick: false,
                    loop: this.product.slideshow ? true : false,
                    initialSlide: 0,
                    autoplay: this.product.slideshow ? {
                        delay: this.product.slideshow_interval * 1000,
                        stopOnLastSlide: false,
                        disableOnInteraction: false
                    } : false,
                    speed: 1000,
                    direction: "horizontal",
                    grabCursor: true,
                    on: {
                        slideChangeTransitionStart: function() {
                        },
                    }
                }
            },

            automaticPromotionText()
            {
                return (this.product.AutomaticPromotions && this.product.AutomaticPromotions.data.length > 0) ? this.product.AutomaticPromotions.data[0].display_text : false;
            },

            automaticPromotionTextLong()
            {
                return (this.product.AutomaticPromotions && this.product.AutomaticPromotions.data.length > 0) ? this.product.AutomaticPromotions.data[0].display_text_long : false;
            },

            // returns '+' seperated string of product anmes in the bundle
            bundleContents()
            {
                if(!this.product.bundle)
                    return '';

                let string = this.product.PriceModifiers.reduce((accumulator, currentValue) => {return accumulator + currentValue.Product.name +' + '},'');
                // remove last +
                return string.substring(0, string.length - 3);

            },

            // creates a user friendly expiry time eg `4 weeks`, `1 years`
            expiryText(){
                if(this.product.CurrentExpiryConfig && this.product.CurrentExpiryConfig.seconds_valid_for){


                    let seconds = this.product.CurrentExpiryConfig.seconds_valid_for;

                    if(seconds >= 15638400 && seconds <= 15811200) // between 181 - 183 days
                        return '6 months';

                    if(seconds >= (31536000 + 15638400) && seconds <= (31536000 + 15811200) ) // between 1 year and 181 - 183 days
                        return '18 months';


                    let numyears = Math.floor(seconds / 31536000);
                    let yearText = numyears ? numyears + ' '+ (numyears > 1 ? 'years' : 'year') : '';
                    let numdays = Math.floor((seconds % 31536000) / 86400);
                    let dayText = numdays ? numdays + ' '+ (numdays > 1 ? 'days' : 'day') : '';
                    let numhours = Math.floor(((seconds % 31536000) % 86400) / 3600);
                    let hourText = numhours ? numhours + ' '+ (numhours > 1 ? 'hours' : 'hour') : '';
                    let numminutes = Math.floor((((seconds % 31536000) % 86400) % 3600) / 60);
                    let minText = numminutes ? numminutes + ' '+ (numminutes > 1 ? 'minutes' : 'minute') : '';
                    let numseconds = (((seconds % 31536000) % 86400) % 3600) % 60;
                    let secondText = numseconds ? numseconds + ' '+ (numseconds > 1 ? 'seconds' : 'second') : '';

                    let text = yearText + ' ' + dayText + ' ' + hourText +' '+ minText +' '+ secondText;
                    text = text.replace(/ {1,}/g," ").trim();
                    return text.replace(/ {1,}/g," "); // strip multiple spaces

                }
                return false;

            },

            hardExpiryText(){
                if(this.product.CurrentExpiryConfig && this.product.CurrentExpiryConfig.hard_expire_at){
                    return this.product.CurrentExpiryConfig.hard_expire_at;
                }
                return false;
            },

            cardActiveText(){
                if(this.product.ValidityRules && this.product.ValidityRules.length > 0){

                    for(var i = 0; i < this.product.ValidityRules.length; i++) {
                        if(this.product.ValidityRules[i].validity_rule_type_id == 1) {
                            let valid_from = this.product.ValidityRules[i].rule;
                            return valid_from;
                        }
                    }
                }
                return false;
            },

            cardBecomeActiveText(){

                if(this.product.ValidityRules && this.product.ValidityRules.length > 0){
                    for(var i = 0; i < this.product.ValidityRules.length; i++) {
                        if(this.product.ValidityRules[i].validity_rule_type_id == 3) {

                            let seconds = this.product.ValidityRules[i].rule;

                            if(seconds >= 604800) // 1 week
                                return '1 week';

                            let numdays = Math.floor((seconds % 31536000) / 86400);
                            let dayText = numdays ? numdays + ' '+ (numdays > 1 ? 'days' : 'day') : '';

                            let text = dayText;
                            text = text.replace(/ {1,}/g," ").trim();
                            return text.replace(/ {1,}/g," "); // strip multiple spaces
                        }
                    }
                }
                return false;
            },

            product(){
                let product = this.$store.getters.getProductBySlug(this.$route.params.product_slug);

                return product;
            },

            products(){
                let products = this.$store.getters.getProducts.filter(product => product.show_on_storefront == true || product.bundle == true);
                return products;
            },

            collections(){
                return this.$store.getters.getCollections;
            },

            isTicket() {
              return this.product.ProductType && this.product.ProductType.id && this.product.ProductType.id == 5
            },

            /**
             * Formats the ticket start date to the format "12 September 2022"
             */
            displayTicketDate() {
                if (this.product.ProductType.id !== 5) return;
                return this.$moment(this.product.TicketProductConfig.event_start_date +'Z').format('Do MMMM YYYY');
            },

            eventDayRelative() {
                const m = this.$moment;
                const raw = this.product?.TicketProductConfig?.event_start_date;
                if (!raw) return null;

                // Treat input as UTC if naive; Moment will display/compare in local tz by default
                const event = m(raw.endsWith('Z') ? raw : raw + 'Z'); // parsed as UTC when Z present
                if (!event.isValid()) return null;

                const now = m(); // local time

                if (event.local().isSame(now, 'day')) return 'today';
                if (event.local().isBefore(now, 'day')) return 'past';
                return 'future';
            },

          /**
           * Show the ticket event times in the correct format
           */
          eventTimes() {
            if (!this.isTicket) return [];

            const m = this.$moment;
            const raw = this.product?.TicketProductConfig?.event_start_date;
            if (!raw) return [];

            // Parse base as UTC, then convert to local
            const baseLocal = m.utc(raw).local();
            const now = m(); // local

            const timesArr = [...(this.product.TicketProductConfig.EventSlots || [])]
              .sort((a, b) => String(a.local_time).localeCompare(String(b.local_time)));

            return timesArr.map(time => {
              const [hStr = '0', mStr = '0'] = String(time.local_time || '').split(':');
              const hh = parseInt(hStr, 10) || 0;
              const mm = parseInt(mStr, 10) || 0;

              // Build local datetime for this slot on the event’s local date
              const eventTimeLocal = baseLocal.clone().hour(hh).minute(mm).second(0).millisecond(0);
              const isPast = eventTimeLocal.isBefore(now);

              return {
                name: m({ hour: hh, minute: mm }).format('h:mma'),
                id: time.id,
                is_past: isPast,
              };
            });
          },




        },
        watch : {

            product(){
                this.setProduct();
            }



        },
        created : function(){
            if(process.client)
                this.getStockFile();
            this.setProduct();
        },
        mounted : function ()
        {
            if(!process.client)
                return false;
            //this.product =  this.getPageData();
            var body = document.body; // Safari
            var html = document.documentElement; // Chrome, Firefox, IE and Opera places the overflow at the <html> level, unless else is specified. Therefore, we use the documentElement property for these browsers
            body.scrollTop = 0;
            html.scrollTop = 0;
        },

        methods:{
            onSlideTransition(){
                this.chosenImageIndex = this.swiper.realIndex;
            },
            setImage(index){
                this.chosenImageIndex = index;
                let slideIndex = this.product.slideshow ? index + 1 : index;
                this.swiper.slideTo(slideIndex, 500, false);
            },
            setProduct()
            {


                if(this.product){

                    // do any of the products in the bundle allow scheduling?
                    this.show_scheduling_flag = false;
                    if (this.product.bundle) {
                        for (let i = 0; i < this.product.PriceModifiers.length; i++) {
                            if (this.getProductByID(this.product.PriceModifiers[i].Product.id).allow_scheduling) {
                                this.show_scheduling_flag = true;
                                break;
                            }
                        }
                    } else {
                        this.show_scheduling_flag = this.product.allow_scheduling;
                    }

                }else
                    this.$router.push({ name: 'notfoundpage'});

            },

        },

        head() {
            return {
                title: this.product.name + ' - ' + this.$store.getters.getAccount.name,
                meta: [
                  {
                    hid: 'og:title',
                    name: 'og:title',
                    property: 'og:title',
                    content: this.product.name + ' - ' + this.$store.getters.getAccount.name
                  },
                  {
                    hid: 'description',
                    name: 'description',
                    content: this.product.short_description
                  },
                  {
                    hid: 'og:url',
                    name: 'og:url',
                    content: 'https://'+this.$store.getters.getAccount.domain+'/shop/'+this.product.slug
                  },
                  {
                    hid: 'og:image',
                    name: 'og:image',
                    content: this.product.Images[0]?.url ?? ''
                  },
                  {
                    hid: 'twitter:image',
                    name: 'twitter:image',
                    content: this.product.Images[0]?.url ?? ''
                  },
                  {
                    hid: 'twitter:description',
                    name: 'twitter:description',
                    content: this.product.short_description
                  },
                  {
                    hid: 'twitter:title',
                    name: 'twitter:title',
                    content: this.product.name + ' - ' + this.$store.getters.getAccount.name
                  },
                  {
                    hid: 'robots',
                    name: 'robots',
                    content: 'noindex, nofollow'
                  },
                ],
                link: [
                    {
                    rel: 'canonical',
                    href: 'https://'+this.$store.getters.getAccount.domain+'/shop/'+this.product.slug
                    }
                ],
                script: [
                  {
                    json: {
                      '@context' : 'https://schema.org',
                      '@type' : 'WebSite',
                      'name' : this.$store.getters.getAccount.name, // Use only the site/account name
                      'alternateName' : this.product.name,
                      'url' : 'https://' + this.$store.getters.getAccount.domain + '/' // Use homepage URL
                    },
                    // Docs for my comments: https://developers.google.com/search/docs/appearance/site-names#json-ld
                    type: 'application/ld+json'
                  }
                ]
            }
        }
    }

